import React from 'react';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    label: {
      fontWeight: 500,
    },
  }),
);

export default function FormFieldLabel(props: TypographyProps) {
  const classes = useStyles();

  return <Typography className={classes.label} {...props} />;
}
